<template>
    <div class="alert" :class="`alert-${type}`">
        <slot>{{ content }}</slot>
    </div>
</template>

<script>
    export default {
        props: {
            type: {type: String, default: 'danger'},
            content: {type: String, default: ''},
        },
    };
</script>
